import { createContext, useState } from "react";
import useFetch from "../hooks/useFetch.js";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const QueryArticlesContext = createContext();

export const QueryArticlesProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortingOption, setSortingOption] = useState("relevance");
  const [page, setPage] = useState(1);

  // search articles based on user search-term request
  let {
    data: articles,
    totalArticles,
    loading,
    error,
  } = useFetch(
    searchTerm ? `${API_URL}/search?q=${searchTerm}` : null,
    true
  );

  // Calculate total articles from our response
  totalArticles = articles?.response?.docs?.length || 0;

  return (
    <QueryArticlesContext.Provider
      value={{
        articles,
        loading,
        error,
        sortingOption,
        setSortingOption,
        searchTerm,
        setSearchTerm,
        page,
        setPage,
        totalArticles,
      }}
    >
      {children}
    </QueryArticlesContext.Provider>
  );
};
